import { useEffect, useRef } from 'react';

export function useParallax(containerRef) {
  const parallaxBgRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const parallaxBg = container.querySelector('.parallax-background');
    if (!parallaxBg) return;

    parallaxBgRef.current = parallaxBg;
    const sensitivity = 0.3;

    const handleMouseMove = (e) => {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      const centerX = container.offsetWidth / 2;
      const centerY = container.offsetHeight / 2;
      
      const moveX = (x - centerX) * sensitivity;
      const moveY = (y - centerY) * sensitivity;
      
      parallaxBg.style.transform = `translate(${moveX}px, ${moveY}px)`;
    };

    const handleMouseLeave = () => {
      parallaxBg.style.transform = 'translate(0, 0)';
    };

    container.addEventListener('mousemove', handleMouseMove);
    container.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      container.removeEventListener('mousemove', handleMouseMove);
      container.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [containerRef]);
}

